import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BreadCrump } from '../../shared/bread-crump/bread-crump';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-advanced-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, BreadCrump, TranslateModule],
  templateUrl: './advanced-search.html',
  styleUrl: './advanced-search.scss',
})
export class AdvancedSearch {
  searchForm: FormGroup;

  // Field options
  fieldOptions = [
    { value: 'all', label: 'advancedSearchPage.fields.all' },
    { value: 'title', label: 'advancedSearchPage.fields.title' },
    { value: 'author', label: 'advancedSearchPage.fields.author' },
    { value: 'subject', label: 'advancedSearchPage.fields.subject' },
    { value: 'publisher', label: 'advancedSearchPage.fields.publisher' },
    { value: 'isbn', label: 'advancedSearchPage.fields.isbn' }
  ];

  constructor(private fb: FormBuilder, private router: Router) {
    this.searchForm = this.fb.group({
      rows: this.fb.array([this.createRow(true)])
    });
  }

  get rows(): FormArray {
    return this.searchForm.get('rows') as FormArray;
  }

  createRow(isFirst: boolean = false): FormGroup {
    return this.fb.group({
      operator: [isFirst ? 'AND' : 'AND'],
      field: ['all'],
      term: ['', Validators.required]
    });
  }

  addRow(): void {
    this.rows.push(this.createRow());
  }

  removeRow(index: number): void {
    if (this.rows.length > 1) {
      this.rows.removeAt(index);
    }
  }

  clearForm(): void {
    this.searchForm.reset();
    this.rows.clear();
    this.addRow();
  }

  onSearch(): void {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }

    const formValue = this.searchForm.value;
    
    // Build array of search rules
    const advSearchRules = formValue.rows.map((row: any, index: number) => ({
      operator: index === 0 ? (row.operator === 'NOT' ? 'NOT' : 'AND') : row.operator,
      field: row.field,
      term: row.term
    }));

    // Stringify and encode to pass in query params
    const advQ = encodeURIComponent(JSON.stringify(advSearchRules));

    // Navigate to browse-index page with adv_q
    this.router.navigate(['/browse-index'], { queryParams: { adv_q: advQ } });
  }
}
